export default class RemoveElPresenter {
  init = () => {
    this.checkForZakeke();
  };

  checkForZakeke = () => {
    if (window.location.href.indexOf('apps/zakeke') != -1) {
      this.checkForLoaded(0, 'div[id*="_ratingbadge"]');
      this.checkForLoaded(0, '#smile-ui-container');
      this.checkForLoaded(0, '._hj_feedback_container');
    } else if (window.location.href.indexOf('/products/') != -1) {
      this.checkForLoaded(0, '#zakeke-product-button');
    }
}      

  checkForLoaded = (attemptCount, el) => {
    const element = document.querySelector(el);
    const _this = this;

    if(element && el == '#zakeke-product-button') {
      if( element.classList.contains('bold_hidden') ) {
        element.classList.remove('bold_hidden');
      }
    } else if ( element ) {
        element.style.display = "none";
        element.classList.add("zakeke_hide");
    } else {

      if( attemptCount < 50 ) {

        setTimeout(function() {
          attemptCount++;
            _this.checkForLoaded(attemptCount, el);
        }, 100);
      }
    }
  }

}
